// extracted by mini-css-extract-plugin
export default {"keycap":"i_qou7XGLY","control":"AoE2hetzP9","shift":"lVirDRiRVb","alt":"W5uaMRAmfo","meta":"YFj1_27wvc","space":"rxs1No0Qc1","enter":"taIhVAQz0I","dark":"fkxXAGGDYe"};